import { Loader } from '@/components/Loader';
import { useLogin } from '@/pages/Login/useLogin';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import styles from './index.module.scss';

export const Login = () => {
    const { form, isLoading, onChange, onSubmit } = useLogin();

    return (
        <div className={styles.layout}>
            {isLoading ? (
                <Loader/>
            ) : (
                <Form className={styles.form} onSubmit={onSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="login">Email</Form.Label>
                        <Form.Control id="login" name="login" value={form.login} onChange={onChange}/>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="password">Password</Form.Label>
                        <Form.Control
                            id="password"
                            name="password"
                            type="password"
                            value={form.password}
                            onChange={onChange}
                        />
                    </Form.Group>
                    <Button type="submit" className={styles.button}>Войти</Button>
                </Form>
            )}
        </div>
    );
};
